import { useAppUpdate } from "@/lib/appUpdate";
import { ArrowClockwise, DownloadSimple } from "@phosphor-icons/react";

// Slim, full-width update banner. Rendered in normal document flow at the top of
// the content area (BELOW the top bar) so it never overlaps the top bar, sidebar,
// help/notification buttons, or any existing UI. Unmounts the moment a refresh is
// triggered and never reappears unless a newer build is detected.
export default function UpdateBanner() {
  const { status, progress, applyUpdate } = useAppUpdate();
  if (status === "idle") return null;

  const ready = status === "ready";

  return (
    <div
      data-testid="update-banner"
      className="mb-5 md:mr-32 rounded-[12px] border border-[#3BB54A]/50 bg-[#EAF7EC] px-4 py-3"
    >
      {ready ? (
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="text-sm font-semibold text-[#2E2E2E] flex items-center gap-2">
            <DownloadSimple size={18} weight="fill" className="text-[#3BB54A]" />
            Update ready
          </p>
          <button
            onClick={applyUpdate}
            data-testid="update-refresh-btn"
            className="text-sm font-bold text-white bg-[#3BB54A] hover:bg-[#2E9E3F] rounded-full px-4 py-2 flex items-center gap-2 transition-colors shrink-0"
          >
            <ArrowClockwise size={16} weight="bold" /> Click to refresh
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <p className="text-sm font-semibold text-[#2E2E2E] flex items-center gap-2">
            <ArrowClockwise size={16} weight="bold" className="text-[#3BB54A] animate-spin" />
            Updating MowGuru…
            <span className="text-xs text-muted-foreground font-medium" data-testid="update-progress-label">{progress}%</span>
          </p>
          <div className="h-2 w-full rounded-full bg-white/70 overflow-hidden">
            <div
              data-testid="update-progress-bar"
              className="h-full bg-[#3BB54A] transition-all duration-200"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
